import lazyLoad from '@utils/lazyLoad'

const IntegralMall = [
  {
    path: '/mall/giftManagement',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/IntegralMall/GiftManagement')
    ),
    meta: {
      layoutMode: 'empty'
    }
  },
  {
    path: '/mall/giftOrder',
    exact: true,
    component: lazyLoad(() => import('@views/Members/IntegralMall/GiftOrder')),
    meta: {
      layoutMode: 'empty'
    }
  },
  {
    path: '/mall/giftManagement/rule-edit/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/IntegralMall/GiftRuleEdit')
    ),
    meta: {
      applicationCode: '7209ebc7-6536-469a-8a52-dac38de3f941',
      title: '编辑规则'
    }
  },
  {
    path: '/mall/giftManagement/rule-new/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/IntegralMall/GiftRuleEdit')
    ),
    meta: {
      applicationCode: '7209ebc7-6536-469a-8a52-dac38de3f941',
      title: '新建规则'
    }
  },
  {
    path: '/mall/giftOrder/detail/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/IntegralMall/GiftOrderDetail')
    )
  }
]

export default IntegralMall
